import { isDefined, isNonEmpty } from '@sgme/fp';
import { useSPIntl } from 'hooks/useIntl';
import { IntlKey } from 'locales';
import { QuoteFormError } from 'state/addonForm/addonForm.selector';

function translateValidationErrorValues(
  values: Record<string, unknown> | undefined,
  { formatMessage, formatDisplayedDate }: ReturnType<typeof useSPIntl>,
) {
  if (isDefined(values)) {
    return Object.keys(values).reduce<Record<string, unknown>>((result, key) => {
      const value = values[key];
      if (typeof value === 'string') {
        if (key.includes('date')) {
          result[key] = formatDisplayedDate(value);
        } else if (isNonEmpty(value)) {
          result[key] = formatMessage({ id: value as IntlKey, defaultMessage: value });
        } else {
          result[key] = value;
        }
      } else {
        result[key] = value;
      }
      return result;
    }, {});
  }
  return {};
}

export function useTranslateValidationError() {
  const intl = useSPIntl();

  function translateError(error: QuoteFormError, errorPrefix?: string) {
    const key = intl.idExists(error.message) ? error.message : error.translationKey;

    if (!key) {
      return error.message;
    }

    return intl.formatMessage(
      { id: (errorPrefix + key) as IntlKey, defaultMessage: key },
      { ...(translateValidationErrorValues(error.values, intl) as Record<string, string>) },
    );
  }

  return translateError;
}
